// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"26ddbbb6","757":"8fa7043f"}[chunkId] + ".chunk.css";
};